import React from 'react';
import { Box, TextField, MenuItem, Typography } from '@mui/material';
import UserAvatar from '../UserAvatar';

const UserSelect = ({ 
  label, 
  value, 
  onChange, 
  options = [], 
  error, 
  helperText,
  disabled = false,
  required = false,
  fullWidth = true,
  permissionError = false
}) => {
  // Remover logs de debug
  const selectedUser = options.find(user => user.id === value);

  // Se houver um erro de permissão, exibir apenas uma mensagem de erro
  if (permissionError) {
    return (
      <TextField
        label={label}
        value=""
        disabled
        fullWidth={fullWidth}
        error
        helperText="Você não tem permissão para visualizar os usuários"
      />
    );
  }

  return (
    <TextField
      select
      label={label}
      value={value || ''}
      onChange={onChange}
      error={!!error}
      helperText={helperText}
      disabled={disabled}
      required={required}
      fullWidth={fullWidth}
    >
      <MenuItem value="">
        <em>Selecione...</em>
      </MenuItem>
      {options.map((user) => (
        <MenuItem key={user.id} value={user.id}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <UserAvatar user={user} />
            <span>
              {user.name}
              {user.nickname && ` (${user.nickname})`}
            </span>
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
};

export default UserSelect;
